/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/style.scss"

export const onRouteUpdate = ({ location, prevLocation }) => {

  try {
    if (window && typeof window.gtag == "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }  catch (error) {
    console.error(error);
  }
};
